export const SET_ACTIVE_PREVIEW = "SET_ACTIVE_PREVIEW";
export const CLOSE_PREVIEW = "CLOSE_PREVIEW";

export const SET_ZOOM_LEVEL = "SET_ZOOM_LEVEL";

export const SET_CLICKED_MARKER = "SET_CLICKED_MARKER";
export const CLEAR_CLICKED_MARKER = "CLEAR_CLICKED_MARKER";

export const TOGGLE_CONTACT_DETAILS = "TOGGLE_CONTACT_DETAILS";
